export default __webpack_public_path__ + "static/telesan_inicio1-1da2416dda559d00059dfd6a845aa586.jpg";